<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M2.15043 5.43275L0.694682 14.6525C0.634172 15.0357 0.965006 15.3665 1.34824 15.3061L10.568 13.8503C11.0766 13.7699 11.4687 13.3594 11.5256 12.8477L12.0007 8.57143L7.42928 4L3.15309 4.47513C2.64129 4.532 2.23073 4.92411 2.15043 5.43275Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.42969 3.99986L9.7154 0.571289"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12 8.57136L15.4286 6.28564"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M1.14453 14.8571L5.71596 10.2856"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.57227 9.14258L6.85798 11.4283"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
